<template>
  <div>
    <div v-if="modules.cards" class="mobile-wrapper column px-gap ww-12/12 flex flex-wrap w-full justify-between align-middle pt-2">
      <Swiper ref="soundSwiper" :options="contentOptions" class="h-full w-full">
        <SwiperSlide v-for="(card, index) in modules.cards" :key="index">
          <div
            class="w-full flex justify-center m-auto items-center border-blue-default hover:bg-blue-darker border-1 rounded-md product-hover-card hover:border-0"
            @click.prevent="playAudio(index)"
          >
            <div>
              <span class="my-0 markdown"
                ><Markdown v-if="card.fields.content" :source="card.fields.content"
              /></span>
              <a
                v-if="card.fields.link"
                class="btn--audio no-underline hover:no-underline font-medium mt-auto inline-block md:mb-1 lg:mb-0 cursor-pointer"
              >
                {{ get(card, "fields.cta[0].fields.text", "Hear in cab alert") }}</a
              >
            </div>
            <audio
              v-if="card.fields.link"
              :ref="`alert-${index}`"
              :data-src="card.fields.link"
              preload="none"
              autoplay="false"
            ></audio>
          </div>
        </SwiperSlide>
      </Swiper>
      <div class="bullets">
        <span
          v-for="(slide, index) in modules.cards"
          :key="index"
          tabindex="0"
          class="bullet"
          :class="{ active: index + 1 === active }"
          @click.prevent="
            () => {
              goToSlide(index + 1);
              touched = false;
            }
          "
          @keyup.enter="
            () => {
              goToSlide(index + 1);
              touched = false;
            }
          "
        ></span>
      </div>
    </div>
    <div
      class="desktop-wrapper w-full column px-gap ww-12/12 flex flex-wrap w-full justify-between align-middle"
      style="min-height: 320px;"
      v-if="modules.cards"
    >
      <div
        v-for="(card, index) in modules.cards"
        :key="index"
        class="w-full flex justify-center m-auto items-center border-blue-default hover:bg-blue-darker border-1 rounded-md product-hover-card hover:border-0"
        @click.prevent="playAudio(index)"
      >
        <div>
          <!-- temp removal
          <img
            v-if="card.fields.image"
            :src="card.fields.image.fields.image.fields.file.url"
            :alt="card.fields.image.fields.image.fields.description"
            data-not-lazy
          /> -->
          <span class="my-0 markdown"
            ><Markdown v-if="card.fields.content" :source="card.fields.content"
          /></span>
          <a
            v-if="card.fields.link"
            class="btn--audio no-underline hover:no-underline font-medium mt-auto inline-block md:mb-1 lg:mb-0 cursor-pointer"
          >
            {{ get(card, "fields.cta[0].fields.text", "Hear in cab alert") }}</a
          >
        </div>
        <audio
          v-if="card.fields.link"
          :ref="`alert-${index}`"
          :data-src="card.fields.link"
          preload="none"
          autoplay="false"
        ></audio>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
::v-deep .product-hover-card {
  width: 220px;
  height: 200px;
  max-height: 200px;
  padding: 25px 25px;
  transition: height 0.4s;

  @media screen and (max-width: 961px) {
    margin-bottom: 20px;
  }

  img {
    display: none;
  }

  h3 {
    font-weight: 600;
  }

  p {
    font-size: 14px;
    line-height: 24px;
    color: #00263e;
    height: 75px;
  }

  &:hover {
    color: white;
    height: 320px;
    max-height: 320px;
    cursor: pointer;

    img {
      display: block;
      padding-bottom: 25px;
    }

    h3,
    p,
    a {
      color: white;
    }

    p {
      margin-bottom: 50px;
    }

    .btn--audio::before {
      background-image: url("https://images.ctfassets.net/bx9krvy0u3sx/05XOiao6HQmwlW2csJWBB/7ddfc629bcc5acf39bd6182aac8eb2f6/Vector.svg");
      width: 18px;
    }
  }
}

::v-deep .markdown {
  h3 {
    font-size: 18px;
  }
}

.btn--audio {
  font-size: 13px;
  letter-spacing: 0;
  position: relative;
  padding: 7px 17px 7px 35px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &::before {
    position: absolute;
    content: "";
    height: 18px;
    width: 20px;
    left: 2px;
    top: 9px;
    background-image: url("https://images.ctfassets.net/bx9krvy0u3sx/3p5D08UVdsfRtvGYaBEC31/691b5be4792dac165c38edc70c1aefba/blue_vector.svg");
  }

  &:hover {
    color: white;
    text-decoration: none;
  }
}
.mobile-wrapper {
  @media (min-width: 736px) {
    display: none;
  }
}
.desktop-wrapper {
  display: none;
  @media (min-width: 736px) {
    display: flex;
    justify-content: space-between;
  }
  .swiper-slide__container {
    max-width: 566px;
    margin: auto;

    p {
      color: #00263e !important;
      line-height: 34px;
    }
    p:first-of-type {
      font-size: 24px;
    }
  }
}
::v-deep .bullets {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  .bullet {
    width: 12px;
    height: 12px;
    display: flex;
    border-radius: 25px;
    background-color: grey;
    margin: 16px;
    cursor: pointer;

    &.active {
      background-color: darkgrey;
    }
  }
}
</style>
<script>
import get from "../../mixins/get.js";
import PictureWrapper from "./PictureWrapper";
import Markdown from "./Markdown";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    PictureWrapper,
    Markdown,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      active: 1,
      contentOptions: {
        loop: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true
        },
        slidesPerView: 1,
        allowTouchMove: true,
        effect: "slide",
        on: {
          slideChange: this.handleSlideChange
        },
      },
    }
  },
  methods: {
    playAudio(id) {
      let audio = this.$refs[`alert-${id}`][0];
      audio.setAttribute("src", audio.getAttribute("data-src"));
      this.$refs[`alert-${id}`][0].play();
    },
    goToSlide(index) {
      this.active = index;
      this.$refs && this.$refs.soundSwiper && this.$refs.soundSwiper.$swiper ? this.$refs.soundSwiper.$swiper.slideTo(index) : null;
    },
    handleSlideChange() {
      this.active = this.$refs && this.$refs.soundSwiper && this.$refs.soundSwiper.$swiper ? this.$refs.soundSwiper.$swiper.activeIndex : 1;
    },
  },
  mixins: [get],
  props: {
    modules: {
      type: Object,
      required: true,
    },
  },
};
</script>
